import { render, staticRenderFns } from "./BookingRoomServiceTable.vue?vue&type=template&id=1469dc23"
import script from "./BookingRoomServiceTable.vue?vue&type=script&lang=js"
export * from "./BookingRoomServiceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports